import { ApiProperty } from "@nestjs/swagger";

export class CartonBoxBDto {
    @ApiProperty()
    cartonBoxId: number;

    @ApiProperty()
    style: string;

    @ApiProperty()
  cartonCode: string;

    @ApiProperty()
    sL: string;
    
    @ApiProperty()
    xlBal: string;


    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
   isActive:boolean;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    updatedUser: string | null;


    @ApiProperty()
    updatedAt: string;
    @ApiProperty()
    createdAt: string;

   

}